/**
 * Maps an offer of GET /api/campaigns/{id} to a Campaign Offers grid row (GAP-1433). The API
 * sends each offer as an offer token, whose value is `offerId`.
 */
export default function normalizeCampaignOffer(data) {
    return {
        offerToken: data.offerId || '',
        offerTokenName: data.name || '',
    };
}
